import { makeStyles } from '@mui/styles'

export default makeStyles((theme: any) => ({
    UserMenuItemSeparator: {
        width: '100%',
        height: '1px',
        background: theme.palette.lightGrey.main,
        opacity: '0.7',
    },

    UserMenuMenuItem: {
        // position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '9px',
        padding: '0',
    },

    UserMenuLink: {
        color: theme.palette.typography.main,
        textDecoration: 'none',
    },

    UserMenuMenuItemLabel: {
        flex: '1',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        '& svg': {
            marginRight: '.5rem',
        },
    },

    UserMenuMenuItemLinkLabel: {
        padding: '1rem',
    },

    // item group style

    userMenuGroup: {
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
    },

    UserMenuDialogListSubMenu: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxHeight: 0,
        opacity: 0,
        overflow: 'hidden',
        transition: 'height .2s ease-out, opacity .2s ease-out',
    },

    UserMenuDialogListSubMenuOpen: {
        maxHeight: '20rem',
        opacity: 1,
    },

    userMenuGroupItemContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '1',
        textAlign: 'center',
        padding: '1rem',
        width: '100%',
        height: '100%',
    },

    // item label styles
    UserMenuMenuItemLabelIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    UserMenuMenuItemLabelText: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    UserMenuMenuItemLabelTextWithIcon: {
        transform: 'translateY(2px)',
        fontWeight: 700,
    },
}))
